import React from 'react'

const AllDoctors = () => {
  return (
    <div>AllDoctors</div>
  )
}

export default AllDoctors